import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

if (process.env.NODE_ENV === 'production') {
  const ravenOptions = {
    release: process.env.__GIT_SHA__,
    environment: process.env.NODE_ENV
  }

  const dsn = 'https://189e708b3aee4cb8afa5d433c8197e81@sentry.aiotools.ovh/6'
  Raven.config(dsn, ravenOptions)
    .addPlugin(RavenVue, Vue)
    .install()
}



// WEBPACK FOOTER //
// ./src/sentry.js